import { render, staticRenderFns } from "./LoginOtp.vue?vue&type=template&id=bc97e2ee"
import script from "./LoginOtp.vue?vue&type=script&lang=ts"
export * from "./LoginOtp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports